<template>
  <div class="circle-bar">
    <icon-circle-bar :class="circleColorClass" :percent="circleBarPercent"/>
    <icon-circle-bar class="circular-chart_substrate" :percent="100"/>
  </div>
</template>

<script>
import { IconCircleBar } from 'Icons';

export default {
  components: {
    IconCircleBar,
  },
  props: {
    percentageToCompletion: Number,
  },
  computed: {
    circleColorClass() {
      if (this.circleBarPercent >= 75) {
        return 'circular-chart_red';
      }
      if (this.circleBarPercent >= 50) {
        return 'circular-chart_orange';
      }
      if (this.circleBarPercent >= 25) {
        return 'circular-chart_yellow';
      }
      return 'circular-chart_green';
    },
    circleBarPercent() {
      return 100 - (this.percentageToCompletion * 100);
    },
  },
};
</script>

<style lang="scss" scoped>
.circle-bar {
  width: 18px;
  height: 18px;
  position: relative;
}

.circular-chart {
  &_substrate {
    position: absolute !important;
    z-index: 1 !important;
    top: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/alertsList/CircleBar.vue